module.exports = __webpack_public_path__ + "static/img/9bg_4.5755ef8.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/9bg_4.png
// module id = 767
// module chunks = 1